import React, { useState } from "react";
import { Container, Grid, TextField, MenuItem, Button, Typography, Box,IconButton, Link, Paper } from "@mui/material";
import { Email, Phone, LocationOn ,Instagram, YouTube, Facebook } from "@mui/icons-material";
import Navbar from "./Navbar";
import Footer from "./Footer";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const inquiryTypes = ["General Inquiry", "Volunteering", "Donations", "Partnerships", "Others"];
const contactMethods = ["Email", "Phone", "WhatsApp"];

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    inquiryType: "",
    preferredContactMethod: "",
    message: "",
  });

  const [statusMessage, setStatusMessage] = useState("");
  const [error, setError] = useState("");

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage("");
    setError("");

    try {
      const response = await axios.post("https://sahakar-pratishatn-ngo-backend-1.onrender.com/api/contacts/contact-us", formData);
      setStatusMessage(response.data.message);
      setFormData({
        fullName: "",
        email: "",
        phoneNumber: "",
        inquiryType: "",
        preferredContactMethod: "",
        message: "",
      });
       toast.success("Form submited successfully Our team will contact you soon .", {
                          position: "top-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                          theme: "light",
                        });
    } catch (err) {
      const errorMsg = err.response?.data?.error || "Something went wrong. Please try again.";
      setError(errorMsg);
    }
  };

  return (
    <>
      <Navbar />
      <Container sx={{ mt: 5, mb: 5 }}>
        <Paper elevation={3} sx={{ padding: 4, borderRadius: 3 }}>
          <Grid container spacing={4}>
            {/* Contact Details Section */}
            {/* <Grid item xs={12} md={5}>
              <Box>
                <Typography variant="h4" gutterBottom>
                  Contact Us
                </Typography>
                <Typography variant="body1" paragraph>
                  We'd love to hear from you! Get in touch with us.
                </Typography>
                <Box display="flex" alignItems="center" gap={1}>
                  <Phone color="primary" />
                  <Typography variant="body1">+1 234 567 890</Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Email color="primary" />
                  <Typography variant="body1">shakary@ngo.org</Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <LocationOn color="primary" />
                  <Typography variant="body1">123 dhule city, Dhule, India</Typography>
                </Box>
              </Box>
            </Grid> */}
<Grid item xs={12} md={5} sx={styles.container}>
      <Typography variant="h4" gutterBottom>
        Contact Us
      </Typography>
      <Typography variant="body1" paragraph>
        We'd love to hear from you! Get in touch with us.
      </Typography>

      {/* Phone */}
      <Box sx={styles.contactItem}>
  <Phone color="primary" />
  <Box>
    <Link href="tel:+918265044891" sx={styles.contactLink}>
      +91 82650 44891
    </Link>
    <br />
    <Link href="tel:+919404476136" sx={styles.contactLink}>
      +91 94044 76136
    </Link>
  </Box>
</Box>

      {/* Email */}
      <Box sx={styles.contactItem}>
        <Email color="primary" />
        <Link href="mailto:sahakaryapratishthan.joinus@gmail.com" sx={styles.contactLink}>
          sahakaryapratishthan.joinus@gmail.com
        </Link>
      </Box>

      {/* Location */}
      <Box sx={styles.contactItem}>
        <LocationOn color="primary" />
        <Typography variant="body1"> 64 B, Om Nagar, Deopur, Dhule, India</Typography>
      </Box>

      {/* Social Media Links */}
      <Box sx={styles.socialIcons}>
        <IconButton
          component="a"
          href="https://www.instagram.com/sahakarya__pratishthan"
          target="_blank"
          rel="noopener noreferrer"
          sx={styles.icon}
        >
          <Instagram />
        </IconButton>

        <IconButton
          component="a"
          href="https://youtube.com/channel/UCGLQ47UyXpYLWEAn_dJbcDA"
          target="_blank"
          rel="noopener noreferrer"
          sx={styles.icon}
        >
          <YouTube />
        </IconButton>

      </Box>
    </Grid>
            {/* Contact Form Section */}
            <Grid item xs={12} md={7}>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Full Name"
                      required
                      variant="outlined"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Email"
                      type="email"
                      required
                      variant="outlined"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Phone Number"
                      type="tel"
                      required
                      variant="outlined"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      select
                      fullWidth
                      label="Inquiry Type"
                      required
                      variant="outlined"
                      name="inquiryType"
                      value={formData.inquiryType}
                      onChange={handleInputChange}
                    >
                      {inquiryTypes.map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      select
                      fullWidth
                      label="Preferred Contact Method"
                      required
                      variant="outlined"
                      name="preferredContactMethod"
                      value={formData.preferredContactMethod}
                      onChange={handleInputChange}
                    >
                      {contactMethods.map((method) => (
                        <MenuItem key={method} value={method}>
                          {method}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Message"
                      multiline
                      rows={4}
                      required
                      variant="outlined"
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      sx={{
                        backgroundColor: "#2E3B55",
                        color: "white",
                        padding: "10px",
                        "&:hover": { backgroundColor: "#1E2A3B" },
                      }}
                    >
                      Send Message
                    </Button>
                  </Grid>
                </Grid>
              </form>
              <ToastContainer />
              {/* Success and Error Messages */}
              {statusMessage && (
                <Typography variant="body1" color="green" sx={{ mt: 2 }}>
                  {statusMessage}
                </Typography>
              )}
              {error && (
                <Typography variant="body1" color="red" sx={{ mt: 2 }}>
                  {error}
                </Typography>
              )}
               
            </Grid>
          </Grid>
        </Paper>
      </Container>
      <Footer />
    </>
  );
};
const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  contactItem: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  contactLink: {
    textDecoration: "none",
    color: "#1976d2",
    fontSize: "1rem",
    "&:hover": {
      textDecoration: "underline",
      color: "#1565c0",
    },
  },
  socialIcons: {
    display: "flex",
    gap: "15px",
    marginTop: "10px",
  },
  icon: {
    color: "#333",
    "&:hover": {
      color: "#ff4081",
      transform: "scale(1.2)",
      transition: "0.3s",
    },
  },
};

export default Contact;
